import { useTracker } from '@archipro-website/tracker';
import { useWebsiteTrackingProxy } from '~/modules/tracking/hook/useWebsiteTrackingProxy';
import { useLoaderData } from 'react-router';
import { useAppDisplayModeContext } from '@archipro-design/aria';
import { ReadMore } from '@archipro-website/rocco';
import type { loader } from '~/routes/_app.project.$urlSegment._index';

interface SummaryData {
    Content: string;
}

interface SummaryProps {
    data: SummaryData;
}

const SummaryOld = ({ data: { Content } }: SummaryProps) => {
    const { mobile } = useAppDisplayModeContext();
    const tracker = useTracker();
    const { project } = useLoaderData<typeof loader>();
    const clickProxy = useWebsiteTrackingProxy({
        professionalID: project.Professional.ID,
        professionalTitle: project.Professional.Title,
        itemType: 'Project',
    });

    return (
        <div
            className={`grid grid-cols-1 px-4.5 py-4.5 md:mb-24 md:max-w-[57.75rem] md:px-0 md:py-0`}
        >
            <ReadMore
                maxLines={5}
                className="text-foreground"
                buttonClassName={`mt-5 md:mt-7.5 bg-transparent text-foreground underline underline-offset-2 font-medium
                    ${mobile ? 'text-sm' : 'text-base md:text-lg'}`}
                readMoreText="Read more"
                readLessText="Read less"
                alwaysShowButton={true}
                onToggle={(isClamped) => {
                    if (!isClamped) {
                        // Track the click event when expanding
                        tracker.log('ProjectDetailsExpandClick', {
                            url: new URL(window.location.href),
                            targetTracker: 'archiproTracker',
                        });
                    }
                }}
            >
                <div
                    className={`${mobile ? 'text-sm' : 'text-base md:text-lg'} [&_li]:mb-0! [&_li_p]:mb-0! [&_ol]:list-inside [&_ol]:list-decimal [&_ol]:leading-[100%]! [&_ul]:list-inside [&_ul]:list-disc [&_ul]:leading-[100%]!`}
                    style={{ lineHeight: mobile ? '1.3' : '1.5' }}
                    dangerouslySetInnerHTML={{ __html: Content }}
                    onClick={clickProxy}
                    onContextMenu={clickProxy}
                />
            </ReadMore>
            <div className="hidden md:block"></div> {/* Spacer on desktop */}
        </div>
    );
};

export default SummaryOld;
